import { Entity, TEntityName } from '@obvious.tech/constellation/Entity'
import { LogEntry } from '../types'

export interface EntityRef {
  id: string
  typeName: string
  // react-admin resource (e.g. "videomanager/api/Camera"), or null when the
  // payload's EntityName is not a registered Constellation entity — in that
  // case the id is still shown but no fetch/navigation is possible.
  resource: string | null
}

function resolveResource(typeName: string): string | null {
  if (typeName === '') return null
  try {
    return Entity.getResource(typeName as TEntityName)
  } catch {
    return null
  }
}

export function getEntityRef(entry: LogEntry): EntityRef | null {
  if (entry.audit?.entityId != null && entry.audit.entityId !== '') {
    return {
      id: entry.audit.entityId,
      typeName: entry.audit.entityType,
      resource: resolveResource(entry.audit.entityType),
    }
  }

  const payload = entry.metadata.payload
  const id = typeof payload?.EntityId === 'string' ? payload.EntityId : ''
  if (id === '') return null
  const typeName =
    typeof payload?.EntityName === 'string' ? payload.EntityName : ''
  return { id, typeName, resource: resolveResource(typeName) }
}

export function getEntityEditUrl(resource: string, id: string): string {
  const { origin, pathname } = window.location
  return `${origin}${pathname}#/${resource}/${encodeURIComponent(id)}`
}
